import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { PrimengModule } from './primeng.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { MaterialModule } from './material.module';
import { OtpAuthorizationComponent } from './login/otp-authorization/otp-authorization.component';
import { NotifyDialogComponent } from './core/notify-dialog/notify-dialog.component';
import { ConfirmDeleteDialogComponent } from './core/confirm-dialog/confirm-delete-dialog.component';
import { BasicAuthInterceptor } from './core/Auth/Auth.interceptor';
import { MessageService } from 'primeng/api';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent,
    NotifyDialogComponent,
    LoginComponent,
    OtpAuthorizationComponent,
    ConfirmDeleteDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxMatIntlTelInputModule,
    MaterialModule,
    PrimengModule,
    NgOtpInputModule,
    ToastrModule.forRoot({
      timeOut: 3000, // Default timeout
      positionClass: 'toast-top-right', // Position of the toast
      preventDuplicates: true, // Prevent duplicate toasts
    }),
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    MessageService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],  // Add this line
  bootstrap: [AppComponent],
  entryComponents:[ConfirmDeleteDialogComponent]
})
export class AppModule { }
